<template>
    <div class="blog-details-area ptb-100">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-8 col-md-12">
                    <div class="blog-details-desc">
                        

                        <div class="article-content">
                            <div class="row">
                               
                                <p>
                                    {{ $t('sidebar_dental_bridges_p_four') }}
                                    <ol>
                                        <li>
                                            <p>{{ $t('sidebar_dental_bridges_four_li_one') }}</p>
                                        </li>
                        
                                        <li>
                                            <p>{{ $t('sidebar_dental_bridges_four_li_two') }}</p>
                                        </li>
                                        <li>
                                            <p>{{ $t('sidebar_dental_bridges_four_li_three') }}</p>
                                        </li>  
                                        <li>
                                            <p>{{ $t('sidebar_dental_bridges_four_li_four') }}</p>
                                        </li>
                                        <li>
                                            <p>{{ $t('sidebar_dental_bridges_four_li_five') }}</p>
                                        </li>          
                                    </ol>
                                </p>                                
                            </div>
                            

                            <div class="article-tag">
                                <span>Share:</span>
                                <a href="https://www.facebook.com/" target="_blank"><i class='bx bxl-facebook'></i></a>
                                <a href="https://twitter.com/?lang=en" target="_blank"><i class='bx bxl-twitter'></i></a>
                                <a href="https://www.linkedin.com/" target="_blank"><i class='bx bxl-linkedin'></i></a>
                                <a href="https://www.instagram.com/" target="_blank"><i class='bx bxl-instagram'></i></a>
                            </div>
                        </div>
                        <div class="related-articles-footer">
                            <div class="row">
                                <div class="col-lg-3 col-md-6 col-sm-12 related-article-item">

                                    <div class="item">
                                        <div class="info">
                                            <h4 class="title usmall">
                                               <router-link to="/denta-bridges-benefits">{{ $t('sidebar_dental_bridges_title') }}</router-link>
                                            </h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-6 col-sm-12 related-article-item">

                                    <div class="item">
                                         
                                        <h4 class="title usmall">
                                            <router-link to="/dental-bridges-alternative-solutions">{{ $t('sidebar_dental_bridges_title_three') }}</router-link>

                                        </h4>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-6 col-sm-12 related-article-item">

                                    <div class="item">
                                        <div class="info">
                                            <h4 class="title usmall">
                                                 <router-link to="/dental-bridges-eating-habbits">{{ $t('sidebar_dental_bridges_title_two') }}</router-link>
                                            </h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-6 col-sm-12 related-article-item">

                                    <div class="item">
                                         
                                        <h4 class="title usmall">
                                                <router-link to="/dental-bridges-types">{{ $t('sidebar_dental_bridges_title_one') }}</router-link>

                                        </h4>
                                    </div>
                                </div>
                                
                            </div>
                        </div>

                        
                    </div>
                </div>

                
                
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'DentalBridgesCare',
    
    
}
</script>


